import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'

// Application identification console log
console.log(`
🛒 BANJINO'S E-COMMERCE SHOP (DTC)
📍 Domain: shop.banjinos.com
📂 Frontend: /frontend-dtc (DTC)
🎯 Purpose: Direct-to-consumer sales, shopping cart, product catalog
🚀 Starting application...
`);

// Configure axios defaults. Same-origin /api so each shop host (prod,
// staging, local) routes via its own nginx /api/ proxy — no cross-origin,
// no in-app-browser breakage. The old `${baseURL}/v1/dtc` pattern pointed
// at a /api/v1/dtc gateway that doesn't exist on the backend (shop routes
// are mounted at /api/v1/shop), so any raw axios.{get,post} call was
// silently 404-ing.
axios.defaults.baseURL = import.meta.env.VITE_API_URL || '/api'

// Vuetify - Full plugin (covers all the components used across views).
// The earlier vuetify-minimal config registered ~14 components but checkout/
// cart/product detail use ~30+ — the minimal config left half the UI silently
// unstyled. Brand theming happens in plugins/vuetify.js.
import vuetify from './plugins/vuetify'


// Import Master Brand System (SCSS) - MUST be AFTER Vuetify to override
import './assets/scss/main.scss'

// Material Design Icons - Import after SCSS to ensure it's not overridden
import '@mdi/font/css/materialdesignicons.css'

// Pinia
import { createPinia } from 'pinia'

// Router
import router from './router'

// Analytics — no-ops if VITE_GA4_MEASUREMENT_ID is unset, so safe to always call.
import analytics from './services/analytics'
analytics.init()

const pinia = createPinia()

// Set up axios interceptors
axios.interceptors.response.use(
  response => response,
  error => {
    // Handle network errors (backend not running)
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED') {
      console.warn('Backend not available - check server connection')
    }
    
    if (error.response?.status === 401) {
      // Check if it's a token expiration
      if (error.response.data?.code === 'TOKEN_EXPIRED' || 
          error.response.data?.error === 'Invalid authentication') {
        // Clear local storage
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('client')
        
        // Clear auth header
        delete axios.defaults.headers.common['Authorization']
        
        // Redirect to login
        router.push('/login')
      }
    }
    return Promise.reject(error)
  }
)

// Set auth header if token exists
const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

const app = createApp(App)
  .use(vuetify)
  .use(pinia)
  .use(router)
  .mount('#app')

// Typography is now handled by the SCSS brand system
// No need for JavaScript font forcing
